/* Segway KSA 2.0 — interactions (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Header: height vars, solid-on-scroll, overlay mode ---------- */
  function initHeader() {
    var header = $('.sg-header');
    if (!header) return;
    var utility = $('.sg-utility');

    function measure() {
      root.style.setProperty('--sg-header-h', header.offsetHeight + 'px');
      root.style.setProperty('--sg-utility-h', utility ? utility.offsetHeight + 'px' : '0px');
      var offset = 0;
      if (utility) {
        var r = utility.getBoundingClientRect();
        offset = Math.max(0, r.bottom);
      }
      root.style.setProperty('--sg-utility-offset', offset + 'px');
    }

    var overlay = document.body.classList.contains('sg-overlay-header');
    function onScroll() {
      measure();
      if (!overlay) return;
      var solid = window.scrollY > 24 || header.matches(':hover') || header.contains(document.activeElement) || header.classList.contains('menu-open');
      header.classList.toggle('is-solid', solid);
    }
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    header.addEventListener('mouseenter', onScroll);
    header.addEventListener('mouseleave', function () { setTimeout(onScroll, 50); });
    header.addEventListener('focusin', onScroll);
    header.addEventListener('focusout', function () { setTimeout(onScroll, 50); });
  }

  /* ---------- Mega menu: click / keyboard open, Esc to close ---------- */
  function initMega() {
    $$('.sg-nav > li.has-mega').forEach(function (li) {
      var btn = $('.sg-nav__link', li);
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'A' && !window.matchMedia('(hover: none)').matches) return;
        e.preventDefault();
        var open = li.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        $$('.sg-nav > li.is-open').forEach(function (o) { if (o !== li) { o.classList.remove('is-open'); var b = $('.sg-nav__link', o); if (b) b.setAttribute('aria-expanded', 'false'); } });
      });
      li.addEventListener('mouseenter', function () { btn.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.sg-nav > li.is-open').forEach(function (li) { li.classList.remove('is-open'); var b = $('.sg-nav__link', li); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); } });
    });
  }

  /* ---------- Search overlay (wraps Dawn predictive search) ---------- */
  function initSearch() {
    var panel = $('#SgSearch');
    if (!panel) return;
    var input = $('input[type="search"]', panel);
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 30);
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-sg-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-sg-search-close]', panel).forEach(function (b) { b.addEventListener('click', close); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $('#SgDrawer');
    if (!drawer) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = $('button, a', drawer.querySelector('.sg-drawer__panel'));
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-sg-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-sg-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Hero slider with tab progress ---------- */
  function initHero(hero) {
    if (hero.dataset.sgReady) return;
    hero.dataset.sgReady = '1';
    var slides = $$('.sg-hero__slide', hero);
    var tabs = $$('.sg-hero__tab', hero);
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var idx = 0;
    var delay = parseFloat(hero.dataset.autoplay || '0') * 1000;
    var timer = null;
    if (!delay || reduceMotion) hero.classList.add('sg-hero--static');

    function go(n, user) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      tabs.forEach(function (t, i) {
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        t.tabIndex = i === idx ? 0 : -1;
        var bar = $('.sg-hero__tab-bar', t);
        if (bar && i === idx) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      if (tabs[idx] && user) tabs[idx].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!delay || reduceMotion || hero.classList.contains('is-paused')) return;
      timer = setTimeout(function () { go(idx + 1); }, delay);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i, true); });
      t.addEventListener('keydown', function (e) {
        var rtl = root.dir === 'rtl';
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + (rtl ? -1 : 1), true); tabs[idx].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx + (rtl ? 1 : -1), true); tabs[idx].focus(); }
      });
    });
    var prev = $('.sg-hero__arrow--prev', hero);
    var next = $('.sg-hero__arrow--next', hero);
    if (prev) prev.addEventListener('click', function () { go(idx - 1, true); });
    if (next) next.addEventListener('click', function () { go(idx + 1, true); });
    hero.addEventListener('mouseenter', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
    hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); schedule(); });
    hero.addEventListener('focusin', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
    hero.addEventListener('focusout', function () { hero.classList.remove('is-paused'); schedule(); });

    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var rtl = root.dir === 'rtl';
      if (Math.abs(dx) > 40) go(idx + ((dx < 0) !== rtl ? 1 : -1), true);
      x0 = null;
    });
    hero.style.setProperty('--autoplay', (delay / 1000 || 6) + 's');
    go(0);
  }

  /* ---------- Horizontal rails ---------- */
  function initRail(rail) {
    if (rail.dataset.sgReady) return;
    rail.dataset.sgReady = '1';
    var track = $('.sg-rail__track', rail);
    var prev = $('[data-rail-prev]', rail.closest('section') || rail);
    var next = $('[data-rail-next]', rail.closest('section') || rail);
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
    function update() {
      var rtl = root.dir === 'rtl';
      var pos = Math.abs(track.scrollLeft);
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max;
      void rtl;
    }
    function move(dir) {
      var rtl = root.dir === 'rtl';
      track.scrollBy({ left: dir * step() * (rtl ? -1 : 1), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(ctx) {
    var els = $$('.sg-reveal:not(.is-in)', ctx);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky add-to-cart (product pages) ---------- */
  function initStickyAtc() {
    var bar = $('#SgStickyAtc');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') || document.querySelector('product-form form');
    var mainBtn = form ? form.querySelector('[type="submit"]') : null;
    var addBtn = $('[data-sg-sticky-add]', bar);
    var buyBtn = $('[data-sg-sticky-buy]', bar);
    var priceEl = $('[data-sg-sticky-price]', bar);

    function variantId() {
      var input = form ? form.querySelector('input[name="id"]') : null;
      return input ? input.value : bar.dataset.variantId;
    }
    function syncState() {
      if (!mainBtn) return;
      var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      if (addBtn) { addBtn.disabled = disabled; }
      if (buyBtn) { buyBtn.classList.toggle('is-disabled', disabled); buyBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false'); }
      if (buyBtn) buyBtn.href = (bar.dataset.cartUrl || '/cart') + '/' + variantId() + ':1';
      var mainPrice = document.querySelector('.product__info-container .price__sale .price-item--sale, .product__info-container .price__regular .price-item--regular');
      if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent.trim();
    }
    if (addBtn) addBtn.addEventListener('click', function () { if (mainBtn) mainBtn.click(); });
    if (buyBtn) buyBtn.addEventListener('click', function (e) { if (buyBtn.getAttribute('aria-disabled') === 'true') e.preventDefault(); });

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncState, 60); });
    }
    if (mainBtn && 'MutationObserver' in window) new MutationObserver(syncState).observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    var target = form || document.querySelector('.product__info-container');
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(target);
    }
    syncState();
  }

  /* ---------- Boot + theme editor support ---------- */
  function boot(ctx) {
    $$('.sg-hero', ctx).forEach(initHero);
    $$('.sg-rail', ctx).forEach(initRail);
    initReveal(ctx);
  }

  function start() {
    initHeader();
    initMega();
    initSearch();
    initDrawer();
    initStickyAtc();
    boot(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); if (e.target.querySelector('.sg-header')) { initHeader(); initMega(); initSearch(); initDrawer(); } });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.sg-hero__slide');
    if (slide) {
      var hero = slide.closest('.sg-hero');
      var i = Array.prototype.indexOf.call(hero.querySelectorAll('.sg-hero__slide'), slide);
      var tab = hero.querySelectorAll('.sg-hero__tab')[i];
      if (tab) tab.click();
      hero.classList.add('is-paused');
    }
  });
})();
